import React, { lazy, Suspense } from 'react';
import { WorkOrderPanel } from '../../../../enums/workOrderView';
import type { WorkOrderFilterRule } from '../../../../types/InfrastructureManagerTypes';
import WorkOrderCalendar from '../WorkOrderCalendar';
import styles from './WorkOrderPanels.module.scss';

const WorkOrderMap = lazy(() => import('./WorkOrderMap'));

interface WorkOrderPanelsProps {
  activePanel: WorkOrderPanel;
  searchTerm: string;
  filters: WorkOrderFilterRule[];
  isSettingsView: boolean;
}

// The calendar stays mounted and is only hidden. The map is unmounted whenever it
// is out of view (freeing its GPU memory) and restored from a camera snapshot.
const WorkOrderPanels = ({ activePanel, searchTerm, filters, isSettingsView }: WorkOrderPanelsProps) => {
  const isMapShown = activePanel === WorkOrderPanel.MAP && !isSettingsView;

  return (
    <div className={styles.workOrderPanels}>
      <div id="work-order-panel-calendar" role="tabpanel" className={styles.workOrderPanel} hidden={activePanel !== WorkOrderPanel.CALENDAR}>
        <WorkOrderCalendar searchTerm={searchTerm} filters={filters} />
      </div>
      <div id="work-order-panel-map" role="tabpanel" className={`${styles.workOrderPanel} ${styles.workOrderMapPanel}`} hidden={!isMapShown}>
        {isMapShown ? (
          <Suspense fallback={null}>
            <WorkOrderMap />
          </Suspense>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(WorkOrderPanels);
